export const bindInput = ({value, onChange=undefined, change=undefined}) => ({
    value: value ?? "",
    onChange: (e) => {
        const newValue = e.target.value;
        return change ? change(() => newValue) : onChange(newValue);
    },
});
